import React, { useContext, useMemo } from 'react';
import { CreateDishContext, ICreateDishContext } from '../../createDishState/createDishContext';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import style from './ControlPanel.module.scss';

const CreateDishControlPanel: React.FC = () => {
	const { changeVisibleForm, visibleForm, defaultCustomerLanguage, translations } =
		useContext<ICreateDishContext>(CreateDishContext);

	const hasTranslationError = useMemo(() => {
		if (!defaultCustomerLanguage) {
			return false;
		}
		const defaultNameTranslation = translations.find(
			(translation) => translation.languageId === defaultCustomerLanguage.id,
		)?.name;
		return !defaultNameTranslation;
	}, [defaultCustomerLanguage, translations]);

	return (
		<div className={style.container} data-test="CreateDishControlPanel">
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('mainForm')}
				isActive={visibleForm === 'mainForm'}
				btnName="mainInfoBookmark"
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('translations')}
				isActive={visibleForm === 'translations'}
				btnName="translationsBookmark"
				isError={hasTranslationError}
			/>
		</div>
	);
};

export default CreateDishControlPanel;
